import { render, staticRenderFns } from "./SysProcess.vue?vue&type=template&id=07708701&scoped=true"
import script from "./SysProcess.vue?vue&type=script&lang=js"
export * from "./SysProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07708701",
  null
  
)

export default component.exports